import React, {
  memo,
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from 'react'
import { IntakeContext } from 'context/IntakeContext'

// @mui material components
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'

// Material Icons
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import { green, blue } from '@mui/material/colors'
import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'

// Soft UI Dashboard PRO React components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DefaultCounterCard from 'components/cards/CounterCards/DefaultCounterCard'
// import styled from 'styled-components'
import { styled } from '@mui/material/styles'
import { CalculationDebug } from './components/CalculationDebug'

//Gauge Chart
import GaugeChart from 'react-gauge-chart'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge'
import GaugeComponent from 'react-gauge-component'

// react-countup components
import CountUp from 'react-countup'
import SoftButton from 'components/SoftButton'

// Dialog
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

//Accordion
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { useDashboardCalculations } from './hooks/useDashboardCalculations'
import { useRetirementGapCalculations } from './hooks/useRetirementGapCalculations'
import { usePARCOScoreCalculations } from './hooks/usePARCOScoreCalculations'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { useAutoUpdateScores } from 'layouts/authenticated/pages/dashboard/hooks/useAutoUpdateScores'
import { UpdatedCalcs } from 'admin/UpdatedCalcs'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { CSAssets } from './components/CSAssets'
import { PropertyAssets } from './components/PropertyAssets'
import { InvestmentAssets } from './components/InvestmentAssets'
import { OtherAssets } from './components/OtherAssets'
import { OtherLiabilities } from './components/OtherLiabilities'
import { MortgageLiabilities } from './components/MortgageLiabilities'
import { CreditCardLiabilities } from './components/CreditCardLiabilities'
import { TspLoans } from './components/TspLoans'
import { BalanceSheetModalForm } from './components/BalanceSheetModalForm'
import { UpdateFieldModalForm } from './components/UpdateFieldModalForm'
import { UpdateRetirementFieldModalForm } from './components/UpdateRetirementFieldModalForm'
import { ImportFromPlaid } from './components/ImportFromPlaid'
import { apiClient } from 'utils/api/apiClient'
import { testIds } from './constants'
import { BalanceSheetRow } from './components/BalanceSheet/BalanceSheetRow'
import TaskRecommendations from './components/TaskRecommendations'
import incomestatementplaceholder from 'assets/images/incomestatementplaceholder.png'
import squaresbackground from 'assets/images/squares.png'

import { NormalizedGrossDialog } from './components/NormalizedGrossDialog'
import { LeaveAndEarnings } from './components/LeaveAndEarnings'
import { callZapier } from 'utils/zapier/callZapier'
import {
  Box,
  Button,
  FormControlLabel,
  Menu,
  MenuItem,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import Slide from '@mui/material/Slide'
import CloseIcon from '@mui/icons-material/Close'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { CheckBox, PhoneCallback } from '@mui/icons-material'

import ZoomLogo from 'assets/images/zoomLogo.png'

// L&E edit modal
import { steps } from 'layouts/onboarding'
import { ModalOnboarding } from 'layouts/onboarding'
import OnboardingInformation from 'components/OnboardingInformation'
import { ImportFromQuiltt } from './components/ImportFromQuiltt'
import { AddFinancialAccount } from './components/BalanceSheet/AddFinancialAccount'

import { format, differenceInMonths } from 'date-fns'
import AppointmentScheduler from 'components/AppointmentScheduler'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const RoundIcon = styled('div')(() => ({
  border: '1px solid #ddd',
  padding: '10px',
  borderRadius: '50%',
  width: '60px',
  height: '60px',
  margin: 'auto',
}))

// if (process.env.NODE_ENV !== 'test') {
//   const surflyNew = (function (s, u, r, f, l, y) {
//     s[f] = s[f] || {
//       init: function () {
//         s[f].q = arguments
//       },
//     }
//     l = u.createElement(r)
//     y = u.getElementsByTagName(r)[0]
//     l.async = 1
//     l.src = 'https://surfly.com/surfly.js'
//     y.parentNode.insertBefore(l, y)
//   })(window, document, 'script', 'Surfly')

//   var settings = {
//     // Surfly session options can be set here, or at the Company/Plan levels.
//     widget_key: '1766d1d6fb23435f84ca7bc9a64a8156',
//   }

//   Surfly.init(settings, function (initResult) {
//     if (initResult.success) {
//       // API calls can now be made!
//       if (!Surfly.isInsideSession) {
//         Surfly.button()
//       }
//     } else {
//       console.log('Surfly was unable to initialize properly.')
//     }
//   })
// }
export const DashboardTwo = memo(() => {
  const {
    intakeState,
    updateUser,
    updateIntakeStateAtKey,
    userTasks,
    isAdmin,
  } = useContext(IntakeContext)
  // If user Logs in but chooses create account bypassing onboarding - kick them back to onboarding
  const navigate = useNavigate()
  function checkUserNoInfo() {
    if (intakeState?.firstName === null && intakeState?.lastName === null) {
      navigate('/onboarding-full')
    }
  }
  useEffect(() => {
    checkUserNoInfo()
    return () => {}
  }, [intakeState, navigate])

  const [searchParams, setSearchParams] = useSearchParams()
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [type, setType] = useState()
  const [name, setName] = useState()
  const [plaidName, setPlaidName] = useState()
  const [subType, setSubType] = useState()
  const [sortKey, setSortKey] = useState()
  const [amount, setAmount] = useState()
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [interestRate, setInterestRate] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [modalTitle, setModalTitle] = useState()
  const [open, setOpen] = useState(false)
  const [openFieldModal, setOpenFieldModal] = useState(false)
  const [updateFieldModalTitle, setUpdateFieldModalTitle] = useState(
    'Update Your TSP Balance'
  )
  const [updateFieldModalUserField, setUpdateFieldModalUserField] =
    useState('tspBalance')
  const [openDialogModal, setOpenDialogModal] = useState(false)
  const [openScheduleModal, setOpenScheduleModal] = useState(false)
  const [openRetirementFieldModal, setOpenRetirementFieldModal] =
    useState(false)
  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])

  const [tableTimeHorizon, setTableTimeHorizon] = useState('monthly')
  const switchTimeHorizon = (event, newTimeHorizon) => {
    newTimeHorizon === null
      ? setTableTimeHorizon('monthly')
      : setTableTimeHorizon(newTimeHorizon)
  }
  const [anchorEl, setAnchorEl] = useState(null)
  const tableMenuOpen = Boolean(anchorEl)
  const handleTableMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleTableMenuClose = () => {
    setAnchorEl(null)
  }
  const [tableStates, setTableStates] = useState({
    values: false,
    expand: false,
    paycheck: false,
    working: false,
    difference: false,
  })
  const handleTableStateChange = (event) => {
    setTableStates({
      ...tableStates,
      [event.target.name]: event.target.checked,
    })
  }
  //Some values for figuring out profile completeness
  const profileCompleteness = Object.values(intakeState).reduce(
    (count, value) => {
      return count + (value === null || value === '' ? 1 : 0)
    },
    0
  )

  const [timeLeft, setTimeLeft] = useState(getHoursUntilSeven())
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getHoursUntilSeven())
    }, 60000) // Update every minute

    return () => clearInterval(timer)
  }, [])
  function getHoursUntilSeven() {
    const now = new Date()
    const estOffset = -5 * 60 // EST offset in minutes
    const nowUtc = now.getTime() + now.getTimezoneOffset() * 60000
    const nowEst = new Date(nowUtc + estOffset * 60000)

    const target = new Date(nowEst)
    target.setHours(18, 0, 0, 0) // 7:00 PM EST

    if (nowEst > target) {
      target.setDate(target.getDate() + 1) // If it's past 7:00 PM, move to next day
    }

    const diffMs = target - nowEst
    const diffHours = diffMs / (1000 * 60 * 60)

    return diffHours.toFixed(0) // Show two decimal places
  }

  const profileCompletionArray = [
    'firstName',
    'lastName',
    'email',
    'zipcode',
    'dateOfBirth',
    'employmentStatus',
    'agency',
    'positionTitle',
    'dateOfHire',
    'retirementSystem',
    'dateOfPlannedRetirement',
    'baseSalary',
    'highThree',
    'currentLeaveBalance',
    'currentSickLeaveBalance',
    'tsp',
    'tspBalance',
    'tspLoans',
    'healthInsurance',
    'healthInsurancePremium',
    'netTakeHome',
    'estimatedSocialSecurity',
    'military',
    'familyMaritalStatus',
    'fegli',
    'lifeInsuranceOther',
  ]
  const profileCompletenessFromArray = profileCompletionArray.reduce(
    (count, attr) => {
      return (
        count + (intakeState[attr] === null || intakeState[attr] === '' ? 1 : 0)
      )
    },
    0
  )
  const profileCompletenessFromArrayValue = Math.round(
    ((profileCompletionArray.length - profileCompletenessFromArray) /
      profileCompletionArray.length) *
      100
  )
  // console.log(profileCompleteness)
  // console.log(profileCompletenessFromArray)
  // console.log(profileCompletenessFromArrayValue)

  const unlockLandE =
    !intakeState?.baseSalary ||
    !intakeState?.highThree ||
    (!intakeState?.estimatedSocialSecurity &&
      intakeState?.retirementSystem !== 'csrs')
  const [tableVilibility, setTableVisibility] = useState(true)
  const toggleTable = () => {
    setTableVisibility(!tableVilibility)
  }

  const getAccounts = useCallback(async () => {
    const {
      data: { items },
    } = await apiClient.get('api/assets')
    const foundAssets = items?.filter(({ type }) => type === 'asset') || []
    setAssets(foundAssets)
    const foundLiabilities =
      items?.filter(({ type }) => type === 'liability') || []
    setLiabilities(foundLiabilities)
    const foundDeductions =
      items?.filter(({ type }) => type === 'deduction') || []
    setDeductions(foundDeductions)
    // setDeductions([
    //   {
    //     typeSubTypeUuid:
    //       'deduction#alotchecking#0194e113-839b-7000-907c-0970a7a467f9',
    //     updatedAt: '2025-02-10T19:36:38.456Z',
    //     subType: 'alotchecking',
    //     amount: 750,
    //     createdAt: '2025-02-07T15:42:20.059Z',
    //     name: 'ALOT - Checking',
    //     keepInRetirement: false,
    //     ownerId: 'ccbd8675-82fb-4e7e-8537-6e2098cf27a9',
    //     type: 'deduction',
    //   },
    //   {
    //     typeSubTypeUuid:
    //       'deduction#alotother#0194f15d-8bf9-7000-9161-a23753716fe3',
    //     updatedAt: '2025-02-10T19:37:07.321Z',
    //     subType: 'alotother',
    //     amount: 300,
    //     createdAt: '2025-02-10T19:37:07.321Z',
    //     name: 'alotother',
    //     keepInRetirement: false,
    //     ownerId: 'ccbd8675-82fb-4e7e-8537-6e2098cf27a9',
    //     type: 'deduction',
    //   },
    //   {
    //     typeSubTypeUuid:
    //       'deduction#alotother#0194f15d-afff-7000-a06f-3cd39a144b0b',
    //     updatedAt: '2025-02-10T19:37:16.543Z',
    //     subType: 'alotother',
    //     amount: 149,
    //     createdAt: '2025-02-10T19:37:16.543Z',
    //     name: 'alotother',
    //     keepInRetirement: false,
    //     ownerId: 'ccbd8675-82fb-4e7e-8537-6e2098cf27a9',
    //     type: 'deduction',
    //   },
    //   {
    //     typeSubTypeUuid: 'deduction#fsa#0194f15c-fbcf-7000-99bd-ab6db94baab4',
    //     updatedAt: '2025-02-10T19:36:30.415Z',
    //     subType: 'fsa',
    //     amount: 58,
    //     createdAt: '2025-02-10T19:36:30.415Z',
    //     name: 'fsa',
    //     keepInRetirement: false,
    //     ownerId: 'ccbd8675-82fb-4e7e-8537-6e2098cf27a9',
    //     type: 'deduction',
    //   },
    // ])
  }, [])

  useEffect(() => {
    let fetched = false
    if (fetched) return

    getAccounts()
    fetched = true
  }, [getAccounts])

  // edit income statement inputs
  const [showModalOnboarding, setShowModalOnboarding] = useState(false)

  const remainingOnboardingSteps = useRef(
    steps.filter((step) => step.tags?.includes('incomeStatement'))
  )
  const closeModalOnboarding = useCallback(() => {
    setShowModalOnboarding(false)
    remainingOnboardingSteps.current = steps.filter((step) =>
      step.tags?.includes('incomeStatement')
    )
  }, [intakeState])
  const openModalOnboarding = useCallback(() => {
    handleTableMenuClose()
    setShowModalOnboarding(true)
  }, [])

  const [showFullModalOnboarding, setShowFullModalOnboarding] = useState(false)
  // console.log(steps)
  const remainingFullOnboardingSteps = useRef(
    steps.filter((step) => step.tags?.includes('onboarding'))
  )
  // console.log(remainingOnboardingSteps)
  const closeFullModalOnboarding = useCallback(() => {
    setShowFullModalOnboarding(false)
    remainingFullOnboardingSteps.current = steps.filter((step) =>
      step.tags?.includes('onboarding')
    )
  }, [intakeState])
  const openFullModalOnboarding = useCallback(() => {
    setShowFullModalOnboarding(true)
  }, [])

  const [showDeferredOnboarding, setShowDeferredOnboarding] = useState(false)
  // console.log(steps)
  const remainingDeferredOnboardingSteps = useRef(
    steps.filter((step) => step.tags?.includes('buyoutFlow'))
  )
  // console.log(remainingOnboardingSteps)
  const closeDeferredModalOnboarding = useCallback(() => {
    setShowDeferredOnboarding(false)
    remainingFullOnboardingSteps.current = steps.filter((step) =>
      step.tags?.includes('buyoutFlow')
    )
  }, [intakeState])
  const openDeferredModalOnboarding = useCallback(() => {
    updateIntakeStateAtKey({ pickYourPath: 3 })
    setShowDeferredOnboarding(true)
  }, [])

  const { valueOfAssets, valueOfInvestableAssets, readinessScoreAdjustedMax } =
    UpdatedCalcs({
      assets,
      liabilities,
    })

  const {
    daysTillRetirement,
    daysSinceRetirement,
    yearsTillRetirement,
    remainingDaysTillRetirement,
    plannedRetirementMonth,
    plannedRetirementDay,
    plannedRetirementYear,
  } = useDashboardCalculations(deductions, liabilities)
  const {
    adjustedNetTakeHomeInRetirement,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeDifferencePARCOGap,
  } = useRetirementGapCalculations(deductions, liabilities)
  const { parcoReadinessScore4Percent } = usePARCOScoreCalculations(
    assets,
    liabilities,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeInRetirement,
    adjustedNetTakeHomeDifferencePARCOGap
  )

  const daysTillHolder =
    typeof yearsTillRetirement !== 'function'
      ? 0
      : yearsTillRetirement(
          daysTillRetirement > 0 ? daysTillRetirement : daysSinceRetirement
        )
  const remainingDaysHolder =
    typeof remainingDaysTillRetirement !== 'function'
      ? 0
      : remainingDaysTillRetirement(
          daysTillRetirement > 0 ? daysTillRetirement : daysSinceRetirement
        )

  const gaugeSettings = {
    width: 150,
    height: 150,
    value: isNaN(parcoReadinessScore4Percent)
      ? 0
      : Math.round(parcoReadinessScore4Percent * 100),
  }

  const gaugeColors = {
    full:
      Math.round(parcoReadinessScore4Percent * 100) > 75
        ? '#4CAF50'
        : Math.round(parcoReadinessScore4Percent * 100) > 55
        ? '#FFCA59'
        : '#FD5C70',
    highlight:
      Math.round(parcoReadinessScore4Percent * 100) > 75
        ? '#c9e7ca'
        : Math.round(parcoReadinessScore4Percent * 100) > 55
        ? '#fcf0d7'
        : '#feced4',
    hover:
      Math.round(parcoReadinessScore4Percent * 100) > 75
        ? '#449d48'
        : Math.round(parcoReadinessScore4Percent * 100) > 55
        ? '#e5b550'
        : '#e35264',
  }

  const bannerColors = {
    full: adjustedNetTakeHomeDifferencePARCOGap <= 0 ? '#4CAF50' : '#FD5C70',
    highlight:
      adjustedNetTakeHomeDifferencePARCOGap <= 0 ? '#c9e7ca' : '#feced4',
    hover: adjustedNetTakeHomeDifferencePARCOGap <= 0 ? '#449d48' : '#e35264',
  }

  const showDeferredResignation =
    intakeState?.workFromHome !== undefined ||
    intakeState?.returnToOffice !== undefined

  const improveScoreHelp = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/3zmzqpy/',
      payload: {
        user: {
          firstName: intakeState.firstName,
          lastName: intakeState.lastName,
          phoneNumber: intakeState.phone,
          email: intakeState.email,
        },
      },
      sendNotification: true,
      notificationMessage:
        'A member of the PARCO team will reach out to you shortly! Expect a call to help improve your retirement readiness.',
    })
  }

  const bridgeMyGapClick = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/2cdwbv4/',
      payload: {
        user: {
          firstName: intakeState?.firstName,
          lastName: intakeState?.lastName,
          phoneNumber: intakeState?.phone,
          email: intakeState?.email,
          score: isNaN(parcoReadinessScore4Percent)
            ? 0
            : parcoReadinessScore4Percent,
          gap: isNaN(adjustedNetTakeHomeDifferencePARCOGap * 12)
            ? 0
            : adjustedNetTakeHomeDifferencePARCOGap * 12,
          investableAssets: isNaN(valueOfInvestableAssets)
            ? 0
            : valueOfInvestableAssets,
        },
      },
      sendNotification: false,
    })
  }

  const handleViewAsset = ({
    id,
    typeSubTypeUuid,
    _version,
    name,
    plaidName,
    amount,
    subType,
    subTypeClassification,
  }) => {
    setType('asset')
    setId(id)
    setVersion(_version)
    setSortKey(typeSubTypeUuid)
    setName(name)
    setPlaidName(plaidName)
    setSubType(subType)
    setAmount(amount)
    setOpen(true)
    setModalTitle(`Update ${name}`)
    setSubTypeClassification(subTypeClassification)
  }

  const handleViewLiability = ({
    id,
    typeSubTypeUuid,
    _version,
    name,
    plaidName,
    amount,
    subType,
    subTypeClassification,
    interestRate,
    loanEndDate,
    monthlyPayment,
  }) => {
    setType('liability')
    setId(id)
    setVersion(_version)
    setSortKey(typeSubTypeUuid)
    setName(name)
    setPlaidName(plaidName)
    setSubType(subType)
    setAmount(amount)
    setOpen(true)
    setModalTitle(`Update ${name}`)
    setSubTypeClassification(subTypeClassification)
    setInterestRate(interestRate)
    setLoanEndDate(loanEndDate)
    setMonthlyPayment(monthlyPayment)
  }

  const handleAssetClickOpen = () => {
    setOpen(true)
    // setSubType('')
    setType('asset')
    setModalTitle('Add An Asset')
  }

  const handleLiabilityClickOpen = () => {
    setOpen(true)
    setSubType('')
    setType('liability')
    setModalTitle('Add a Liability')
  }

  const handleSubmit = () => {
    handleClose()
  }

  const handleClose = () => {
    setOpen(false)
    setVersion('')
    setId('')
    setType('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setModalTitle('')
    setSubTypeClassification('')
    setInterestRate('')
    setLoanEndDate('')
    setMonthlyPayment('')
  }
  const handleFieldModalClose = () => {
    setOpenFieldModal(false)
    updateUser()
  }
  const handleRetirementFieldModalOpen = () => {
    setOpenRetirementFieldModal(true)
  }
  const handleRetirementFieldModalClose = () => {
    setOpenRetirementFieldModal(false)
    updateUser()
  }
  const handleDialogModalOpen = () => {
    setOpenDialogModal(true)
  }
  const handleDialogModalClose = () => {
    setOpenDialogModal(false)
  }
  const handleScheduleModalOpen = () => {
    setOpenScheduleModal(true)
  }
  const handleScheduleModalClose = () => {
    setOpenScheduleModal(false)
  }
  const handleCallMeClose = () => {
    improveScoreHelp()
    setOpenDialogModal(false)
  }
  const handleScheduleCallClose = () => {
    setOpenDialogModal(false)
  }

  const { updateIntakeStateAndSubmit } = useFormDebounce()

  useAutoUpdateScores({
    intakeState,
    updateIntakeStateAndSubmit,
    updateIntakeStateAtKey,
    assets,
    liabilities,
    deductions,
  })

  //Currency Formatting
  const dollarFormat = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })

  const assetSum =
    (assets || []).map((assets) => assets.amount).reduce((a, b) => a + b, 0) +
    (intakeState.tspBalance ? intakeState.tspBalance : 0) +
    (intakeState.tspRothBalance ? intakeState.tspRothBalance : 0)

  const liabilitySum = (liabilities || [])
    .map((liabilities) => liabilities.amount)
    .reduce((a, b) => a + b, 0)

  const netWorth = assetSum - liabilitySum

  const [greeting, setGreeting] = useState('Hello')

  useEffect(() => {
    const getGreeting = () => {
      const hour = new Date().getHours()
      if (hour < 12) return 'Good Morning'
      if (hour < 18) return 'Good Afternoon'
      return 'Good Evening'
    }

    setGreeting(getGreeting())
  }, [])

  return (
    <DashboardLayout>
      <BalanceSheetModalForm
        handleClose={handleClose}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={getAccounts}
        modalHeader={modalTitle}
      />
      <UpdateFieldModalForm
        handleClose={handleFieldModalClose}
        open={openFieldModal}
        handleSubmit={handleFieldModalClose}
        title={updateFieldModalTitle}
        userField={updateFieldModalUserField}
      />
      <UpdateRetirementFieldModalForm
        handleClose={handleRetirementFieldModalClose}
        open={openRetirementFieldModal}
      />
      <Dialog
        open={openDialogModal}
        TransitionComponent={Transition}
        onClose={handleDialogModalClose}
        aria-labelledby="improve-score-dialog-title"
        aria-describedby="improve-score-dialog-description"
      >
        <DialogTitle
          id="improve-score-dialog-title"
          sx={{ paddingRight: '40px' }}
        >
          {'A PARCO Team Member is ready to help!'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDialogModalClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#344767',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ paddingTop: '0px' }}>
          <DialogContentText id="improve-score-dialog-description">
            Let us know when we can contact you so we can work on getting you
            retirement ready by your planned retirement date.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Button
            rel="noreferrer"
            size="large"
            variant="contained"
            startIcon={<PhoneCallback />}
            sx={{
              fontSize: '15px',
              padding: '12px 24px',
              backgroundColor: '#344767',
              color: '#fff',
              fontWeight: 'normal',
              boxShadow: 'none',
              textTransform: 'capitalize',
              letterSpacing: 0.5,
              borderRadius: '6px',
              '&>span>svg': { fontSize: '1rem !important' },
              '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                transform: 'none',
                backgroundColor: '#293852',
                boxShadow: 'none',
              },
            }}
            onClick={handleCallMeClose}
          >
            Call Me Now
          </Button>
          <Button
            startIcon={<CalendarTodayIcon />}
            size="large"
            variant="contained"
            rel="noopener noreferrer"
            onClick={handleScheduleModalOpen}
            sx={{
              fontSize: '15px',
              padding: '12px 24px',
              backgroundColor: '#344767',
              color: '#fff',
              fontWeight: 'normal',
              boxShadow: 'none',
              textTransform: 'capitalize',
              letterSpacing: 0.5,
              borderRadius: '6px',
              '&>span>svg': { fontSize: '1rem !important' },
              '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                transform: 'none',
                backgroundColor: '#293852',
                boxShadow: 'none',
              },
            }}
          >
            Schedule An Appointment
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openScheduleModal}
        TransitionComponent={Transition}
        onClose={handleScheduleModalClose}
        aria-labelledby="improve-score-dialog-title"
        aria-describedby="improve-score-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleScheduleModalClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#344767',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ paddingTop: '0px' }}>
          <AppointmentScheduler
            closeModal={handleScheduleModalClose}
            // isAdmin={isAdmin}
          />
        </DialogContent>
      </Dialog>
      {/* <DashboardNavbar /> */}

      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
        pb={6}
      >
        <Grid item xs={12} mb={2} mt={6}>
          <Typography
            variant="h1"
            fontWeight="600"
            fontSize="28px"
            textAlign="left"
            color="#262627"
          >
            {intakeState?.firstName
              ? `${greeting}, ${intakeState.firstName}`
              : `${greeting}!`}
          </Typography>
        </Grid>
        <Grid container spacing={{ xs: 1, lg: 3 }}>
          <Grid item xs={12} xl={6} xxl={5}>
            <Grid container spacing={{ xs: 1, lg: 3 }}>
              {!intakeState?.estimatedSocialSecurity &&
                intakeState?.retirementSystem !== 'csrs' && (
                  <>
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          textAlign: 'left',
                          boxShadow: 1,
                          borderRadius: 2,
                          backgroundColor: '#E4F0FF',
                          border: '4px solid #ADC5E3',
                        }}
                      >
                        <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                          <Box display="flex">
                            <Box textAlign="left" width="100%">
                              <Typography
                                variant="h3"
                                fontWeight="600"
                                mb={1}
                                fontSize="18px"
                                color="#262627"
                              >
                                Complete Your Profile
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{ lineHeight: '1.2' }}
                                mb={{ xs: 2, md: 3 }}
                                fontSize="16px"
                                color="#262627"
                              >
                                Finish onboarding to get your profile creation
                                off to a good start!
                              </Typography>
                              <Button
                                rel="noreferrer"
                                size="large"
                                variant="contained"
                                onClick={openFullModalOnboarding}
                                sx={[
                                  {
                                    fontSize: '15px',
                                    padding: '12px 24px',
                                    backgroundColor: '#344767',
                                    color: '#fff',
                                    fontWeight: 'normal',
                                    boxShadow: 'none',
                                    textTransform: 'capitalize',
                                    letterSpacing: 0.5,
                                    borderRadius: '6px',
                                  },
                                  {
                                    '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                      {
                                        transform: 'none',
                                        backgroundColor: '#293852',
                                        boxShadow: 'none',
                                      },
                                  },
                                ]}
                              >
                                Finish Onboarding
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Card>
                    </Grid>
                    <ModalOnboarding
                      open={showFullModalOnboarding}
                      handleClose={closeFullModalOnboarding}
                      modalHeader={'Complete Onboarding'}
                      steps={remainingFullOnboardingSteps.current}
                    />
                  </>
                )}
              {/* <Grid item xs={12}>
                <Card
                  sx={{
                    textAlign: 'left',
                    boxShadow: 1,
                    borderRadius: 2,
                    backgroundColor: '#E4F0FF',
                    border: '4px solid #ADC5E3',
                  }}
                >
                  <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                    <Box display="flex">
                      <Box textAlign="left" width="100%">
                        <Box display="flex" alignItems="center">
                          <Box sx={{ marginRight: '12px' }}>
                            <img
                              src={ZoomLogo}
                              alt="Logo"
                              width="50"
                              height="50"
                            />
                          </Box>
                          <Box>
                            <Typography
                              variant="h3"
                              fontWeight="600"
                              // mb={1}
                              fontSize="18px"
                              color="#262627"
                            >
                              Now What? Deferred Resignation Program Conclusion
                              and Next Steps
                            </Typography>
                          </Box>
                        </Box>
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ lineHeight: '1.2' }}
                            my={2}
                            fontSize="16px"
                            color="#262627"
                            fontWeight={500}
                          >
                            Feb 18th @ 7:00 PM EST (in {timeLeft} Hours)
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{ lineHeight: '1.2' }}
                            my={2}
                            fontSize="14px"
                            color="#262627"
                          >
                            The Government just closed the Deferred Resignation
                            Program (DRP). Many accepted and many didn't. We'll
                            walk through what could come next and how to best
                            prepare.
                          </Typography>
                        </Box>
                        <Button
                          size="large"
                          fullWidth
                          variant="contained"
                          href="https://us06web.zoom.us/webinar/register/WN_IefCTpDDS1G6yAJJzBhnyg"
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={[
                            {
                              fontSize: '15px',
                              padding: '12px 24px',
                              backgroundColor: '#344767',
                              color: '#fff',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              textTransform: 'capitalize',
                              letterSpacing: 0.5,
                              borderRadius: '6px',
                            },
                            {
                              '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                {
                                  transform: 'none',
                                  backgroundColor: '#293852',
                                  boxShadow: 'none',
                                },
                            },
                          ]}
                        >
                          Register Here
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Grid> */}
              <Grid item xs={12}>
                <Card
                  sx={{
                    textAlign: 'left',
                    boxShadow: 1,
                    borderRadius: 2,
                    backgroundColor: '#E4F0FF',
                    border: '4px solid #ADC5E3',
                  }}
                >
                  <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                    <Box display="flex">
                      <Box textAlign="left" width="100%">
                        <Box display="flex" alignItems="center">
                          {/* <Box sx={{ marginRight: '12px' }}>
                            <img
                              src={ZoomLogo}
                              alt="Logo"
                              width="50"
                              height="50"
                            />
                          </Box> */}
                          <Box>
                            <Typography
                              variant="h3"
                              fontWeight="600"
                              mb={1}
                              fontSize="18px"
                              color="#262627"
                            >
                              Grab an Appointment with PARCO
                            </Typography>
                          </Box>
                        </Box>
                        <Box>
                          {/* <Typography
                            variant="body1"
                            sx={{ lineHeight: '1.2' }}
                            my={2}
                            fontSize="16px"
                            color="#262627"
                            fontWeight={500}
                          >
                            Jan 30th @ 7:00 PM EST (in {timeLeft} Hours)
                          </Typography> */}
                          <Typography
                            variant="body1"
                            sx={{ lineHeight: '1.2' }}
                            mb={2}
                            fontSize="14px"
                            color="#262627"
                          >
                            Covering everything you need to know to confidently
                            plan for retirement as a federal worker.
                          </Typography>
                        </Box>
                        <Button
                          startIcon={<CalendarTodayIcon />}
                          size="large"
                          fullWidth
                          variant="contained"
                          rel="noopener noreferrer"
                          onClick={handleScheduleModalOpen}
                          sx={{
                            fontSize: '15px',
                            padding: '12px 24px',
                            backgroundColor: '#344767',
                            color: '#fff',
                            fontWeight: 'normal',
                            boxShadow: 'none',
                            textTransform: 'capitalize',
                            letterSpacing: 0.5,
                            borderRadius: '6px',
                            '&>span>svg': { fontSize: '1rem !important' },
                            '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                              transform: 'none',
                              backgroundColor: '#293852',
                              boxShadow: 'none',
                            },
                          }}
                        >
                          Schedule An Appointment
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card
                  sx={{
                    textAlign: 'left',
                    boxShadow: 0,
                    borderRadius: 2,
                    border: '1px solid #D2D6DA',
                  }}
                >
                  <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                    <Box display="flex">
                      <Box textAlign="left" width="100%">
                        <Typography
                          variant="h3"
                          fontWeight="medium"
                          color="#75787B"
                          mb={{ xs: 1, md: 2 }}
                          fontSize="18px"
                          textAlign="left"
                        >
                          My To Do List
                        </Typography>
                        <TaskRecommendations
                          userTasks={userTasks}
                          userAssets={assets}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card
                  sx={{
                    textAlign: 'left',
                    boxShadow: 0,
                    borderRadius: 2,
                    border: '1px solid #D2D6DA',
                  }}
                >
                  <Box lineHeight={1}>
                    <Box display="flex" width="100%" flexDirection="column">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={2}
                      >
                        <Typography
                          variant="h3"
                          fontWeight="medium"
                          color="#75787B"
                          my={2}
                          fontSize="18px"
                          textAlign="left"
                        >
                          My Balance Sheet
                        </Typography>
                        <ImportFromQuiltt handleUpdateAccounts={getAccounts} />
                        {/* <AddFinancialAccount
                          handleUpdateAccounts={getAccounts}
                          addFinancialAccountButtonText="Add Account"
                        /> */}
                      </Box>
                      <BalanceSheetRow
                        accounts={assets}
                        handleAddAccount={handleAssetClickOpen}
                        category={'AllAssets'}
                        handleViewAccount={handleViewAsset}
                        accountType="Assets"
                        addAccountButtonText="Add An Asset"
                        assetsWithTSP={assetSum}
                      />
                      <BalanceSheetRow
                        accounts={liabilities}
                        handleAddAccount={handleLiabilityClickOpen}
                        category={'AllLiabilities'}
                        handleViewAccount={handleViewLiability}
                        accountType="Liabilities"
                        addAccountButtonText="Add a Liability"
                      />
                      <Accordion
                        sx={{
                          '&.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root':
                            {
                              padding: '0 12px 0 16px',
                            },
                          '&.MuiPaper-root.MuiAccordion-root.Mui-expanded': {
                            boxShadow: 'none',
                            marginTop: '0',
                            backgroundColor: '#fafafb',
                          },
                          '.MuiAccordionSummary-root:hover': {
                            backgroundColor: '#fafafb',
                          },
                          '.MuiAccordionSummary-root.Mui-expanded': {
                            minHeight: '48px',
                            backgroundColor: '#fafafb',
                            borderTop: '1px solid #ddd',
                          },
                          '.MuiAccordionSummary-content': {
                            margin: '0',
                            justifyContent: 'space-between',
                          },
                          '.MuiAccordionSummary-content>p': {
                            padding: '12px 0',
                            // minWidth: '135px',
                          },
                          '.MuiAccordionSummary-content>p:nth-of-type(2)': {
                            padding: '12px 0 12px 16px',
                            textAlign: 'right',
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel3-content"
                          id="panel3-header"
                        >
                          <Typography
                            textAlign="left"
                            color="#262627"
                            variant="body2"
                            fontWeight="bold"
                          >
                            Net Worth
                          </Typography>
                          <Typography
                            textAlign="right"
                            color="#262627"
                            variant="body2"
                            fontWeight="bold"
                            sx={{ marginRight: '10px' }}
                          >
                            {dollarFormat.format(netWorth)}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography textAlign="center" color="#262627" pt={1}>
                            Total Assets - Total Liabilities<br></br>
                            {dollarFormat.format(assetSum)} -{' '}
                            {dollarFormat.format(liabilitySum)}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card
                  sx={{
                    textAlign: 'left',
                    boxShadow: 0,
                    borderRadius: 2,
                    border: '1px solid #D2D6DA',
                  }}
                >
                  <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                    <Box display="flex">
                      <Box textAlign="left">
                        <Typography
                          variant="h3"
                          fontWeight="medium"
                          color="#75787B"
                          mb={0}
                          fontSize="18px"
                          textAlign="left"
                        >
                          Retirement Readiness
                        </Typography>
                        <Box
                          display="flex"
                          columnGap={2}
                          sx={{
                            // '.semicircle-gauge>svg>g': {
                            //   transform: 'translate(0px, 25px)',
                            // },
                            '.semicircle-gauge': {
                              maxWidth: '150px',
                            },
                            '.semicircle-gauge>svg>g>g>text': {
                              transform: 'translate(0px, 8px)',
                            },
                            '.semicircle-gauge>svg>g>g>circle': {
                              transform: `translate(${
                                (isNaN(parcoReadinessScore4Percent)
                                  ? 0
                                  : parcoReadinessScore4Percent) * 3
                              }px, -5px)`,
                              filter:
                                'drop-shadow(0px 2px 1.5px rgba(0,0,0,0.3))',
                            },
                          }}
                        >
                          {/* <Gauge
                            {...gaugeSettings}
                            cornerRadius="50%"
                            sx={(theme) => ({
                              ['&.MuiGauge-root']: {
                                overflow: 'visible',
                                flexGrow: 'unset',
                              },
                              [`& .${gaugeClasses.valueText}`]: {
                                fontSize: 48,
                                fontWeight: 'bold',
                              },
                              [`& svg`]: {
                                backgroundColor: '#fff',
                                borderRadius: '50%',
                                width: '150px',
                                height: '150px',
                              },
                              [`& .${gaugeClasses.valueArc}`]: {
                                fill: gaugeColors.full,
                              },
                              [`& .${gaugeClasses.referenceArc}`]: {
                                fill: '#ddd',
                              },
                            })}
                          /> */}
                          <GaugeComponent
                            type="semicircle"
                            marginInPercent={{
                              top: 0.06,
                              bottom: 0.0,
                              left: 0.02,
                              right: 0.02,
                            }}
                            arc={{
                              colorArray: ['#FD5C70', '#FFCA59', '#4CAF50'],
                              padding: 0.04,
                              width: 0.15,
                              subArcs: [
                                { limit: 55 },
                                { limit: 75 },
                                { limit: 100 },
                              ],
                            }}
                            labels={{
                              valueLabel: {
                                style: {
                                  fill: '#262627',
                                  textShadow: 'none',
                                  fontSize: '120px',
                                  fontWeight: 700,
                                },
                                formatTextValue: (value) => {
                                  return value
                                },
                              },
                              tickLabels: {
                                hideMinMax: true,
                              },
                            }}
                            pointer={{
                              type: 'blob',
                              // animate: false,
                              animationDelay: 0,
                              width: 24,
                            }}
                            value={
                              isNaN(parcoReadinessScore4Percent)
                                ? 0
                                : Math.round(parcoReadinessScore4Percent * 100)
                            }
                          ></GaugeComponent>
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignSelf="center"
                            sx={{ padding: '5px 0px' }}
                          >
                            <Typography
                              variant="h4"
                              fontSize="18px"
                              fontWeight={600}
                              color="#262627"
                            >
                              {Math.round(parcoReadinessScore4Percent * 100) >
                              80
                                ? 'On Track'
                                : 'Not On Track'}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontSize="16px"
                              lineHeight="normal"
                              color="#495057"
                            >
                              {plannedRetirementDay
                                ? `Based on your retirement goal of${' '}
                              ${plannedRetirementMonth} ${plannedRetirementDay},${' '}
                              ${plannedRetirementYear}.`
                                : 'Based on your goal retirement date.'}
                            </Typography>
                          </Box>
                        </Box>
                        <Button
                          rel="noreferrer"
                          size="large"
                          fullWidth
                          variant="contained"
                          onClick={handleDialogModalOpen}
                          startIcon={<AddCircleIcon />}
                          sx={{
                            fontSize: '15px',
                            padding: '12px 24px',
                            backgroundColor: '#344767',
                            color: '#fff',
                            fontWeight: 'normal',
                            boxShadow: 'none',
                            textTransform: 'capitalize',
                            letterSpacing: 0.5,
                            borderRadius: '6px',
                            '&>span>svg': { fontSize: '1rem !important' },
                            '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                              transform: 'none',
                              backgroundColor: '#293852',
                              boxShadow: 'none',
                            },
                          }}
                        >
                          Improve My Score Now
                        </Button>
                        <Typography
                          variant="body2"
                          fontWeight="light"
                          fontSize="16px"
                          lineHeight="normal"
                          color="#495057"
                          mt={1}
                        >
                          Your PARCO score is calculated using your financial
                          information and your retirement date. It represents
                          your retirement preparedness.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          {/* Change Back when we integrate with Plaid */}
          <Grid item xs={12} xl={6} xxl={7}>
            {/* <Grid item xs={12}> */}
            <Grid container spacing={{ xs: 1, lg: 3 }}>
              {unlockLandE ? (
                <Grid item xs={12}>
                  <Card
                    sx={{
                      textAlign: 'center',
                      boxShadow: 0,
                      borderRadius: 2,
                      border: '1px solid #D2D6DA',
                    }}
                  >
                    <Box
                      p={{ xs: 3, md: 6 }}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        backgroundImage: `url(${squaresbackground})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          width: '100%',
                          height: '100%',
                          background:
                            'linear-gradient(to bottom,  rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%,rgba(255,255,255,1) 100%)',
                          top: 0,
                          left: 0,
                        },
                      }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Box
                          sx={{
                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              background:
                                'linear-gradient(to bottom,  rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%,rgba(255,255,255,1) 80%)',
                              top: 0,
                              left: 0,
                            },
                          }}
                        >
                          <img
                            src={incomestatementplaceholder}
                            style={{
                              display: 'block',
                              margin: 'auto',
                              maxWidth: '100%',
                            }}
                          />
                        </Box>
                      </Box>
                      <Box>
                        <Typography
                          variant="h3"
                          textTransform="capitalize"
                          fontSize={{ xs: '20px', md: '24px' }}
                          color="#262627"
                        >
                          Complete My Income Statement
                        </Typography>
                      </Box>
                      <Box sx={{ maxWidth: '80%', margin: 'auto' }}>
                        <Typography
                          variant="body1"
                          sx={{ lineHeight: 1.2 }}
                          fontSize={{ xs: '16px', md: '18px' }}
                          my={2}
                          color="#262627"
                        >
                          Access your L&E Statement and Retirement Gap by
                          completing the paystub section of your PARCO
                          onboarding.
                        </Typography>
                        <Button
                          size="large"
                          variant="contained"
                          startIcon={<EditIcon />}
                          onClick={openModalOnboarding}
                          sx={[
                            {
                              fontSize: '15px',
                              padding: '12px 24px',
                              backgroundColor: '#344767',
                              color: '#fff',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              textTransform: 'capitalize',
                              letterSpacing: 0.5,
                              borderRadius: '6px',
                            },
                            {
                              '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                {
                                  transform: 'none',
                                  backgroundColor: '#293852',
                                  boxShadow: 'none',
                                },
                            },
                          ]}
                        >
                          Determine My Retirement Gap
                        </Button>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Accordion
                    onClick={bridgeMyGapClick}
                    sx={{
                      borderRadius: '8px',
                      '&.MuiPaper-root.MuiAccordion-root': {
                        boxShadow: 'none',
                      },
                      '.MuiAccordionSummary-root': {
                        backgroundColor: bannerColors.full,
                        borderRadius: '8px 8px 0 0',
                        border: '1px solid #D2D6DA',
                      },
                      '.MuiAccordionSummary-root:hover': {
                        backgroundColor: bannerColors.hover,
                      },
                      '.MuiAccordionSummary-root.Mui-expanded': {
                        minHeight: '48px',
                      },
                      '.MuiAccordionSummary-root:hover .nav-label': {
                        textDecoration: 'underline',
                      },
                      '.MuiAccordionSummary-root.Mui-expanded .nav-label::before':
                        {
                          content: '"<"',
                          textDecoration: 'none',
                          display: 'inline-block',
                          marginRight: '5px',
                        },
                      '.MuiAccordionSummary-root:not(.Mui-expanded) .nav-label::after':
                        {
                          content: '">"',
                          textDecoration: 'none',
                          display: 'inline-block',
                          marginLeft: '5px',
                        },
                      '.MuiAccordionSummary-content': {
                        margin: '0',
                        justifyContent: 'space-between',
                      },
                      '.MuiAccordionSummary-content>p': {
                        padding: '12px 0',
                      },
                    }}
                  >
                    <AccordionSummary
                      aria-controls="retirementGap-content"
                      id="retirementGap-header"
                      onClick={toggleTable}
                    >
                      <Box
                        display="flex"
                        width="100%"
                        color="#fff"
                        justifyContent="space-between"
                        mt={3}
                      >
                        <Box>
                          <Typography
                            variant="body2"
                            fontWeight="400"
                            sx={{
                              position: 'absolute',
                              top: '10px',
                              fontSize: '14px',
                            }}
                            className="nav-label"
                          >
                            {tableVilibility ? 'Click to learn more' : 'Back'}
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="500"
                            lineHeight={2}
                            fontSize={{ xs: '16px', md: '24px' }}
                          >
                            {adjustedNetTakeHomeDifferencePARCOGap < 0
                              ? 'Your Retirement Surplus:'
                              : 'Your Retirement Gap:'}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant="body2"
                            fontWeight="500"
                            textAlign="right"
                            fontSize="14px"
                            display="inline"
                            lineHeight={2}
                            sx={{ verticalAlign: 'top', marginRight: '2px' }}
                          >
                            $
                          </Typography>
                          <Typography
                            variant="body2"
                            fontSize="30px"
                            fontWeight="500"
                            display="inline"
                          >
                            {dollarFormat
                              .format(
                                Math.abs(
                                  tableTimeHorizon === 'monthly'
                                    ? adjustedNetTakeHomeDifferencePARCOGap
                                    : adjustedNetTakeHomeDifferencePARCOGap * 12
                                )
                              )
                              .slice(1)}
                            <Typography
                              variant="body2"
                              fontWeight="500"
                              textAlign="right"
                              fontSize="14px"
                              display="inline"
                            >
                              {tableTimeHorizon === 'monthly'
                                ? ' /month'
                                : ' /year'}
                            </Typography>
                          </Typography>
                        </Box>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        borderRadius: '0 0 8px 8px',
                        border: '1px solid #D2D6DA',
                      }}
                    >
                      <Box p={1}>
                        <Typography textAlign="left" variant="h4" mb={2}>
                          Bridge Your Retirement Gap With A PARCO Team Member!
                        </Typography>
                        <Typography textAlign="left" variant="body2">
                          Let us know when we can contact you so we can work on
                          bridging your income gap as soon as possible! This
                          will be the key to increasing your PARCO score to get
                          you retirement ready.
                        </Typography>
                        <Box
                          mt={2}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Button
                            rel="noreferrer"
                            size="large"
                            variant="contained"
                            startIcon={<PhoneCallback />}
                            sx={{
                              fontSize: '15px',
                              padding: '12px 24px',
                              backgroundColor: '#344767',
                              color: '#fff',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              textTransform: 'capitalize',
                              letterSpacing: 0.5,
                              borderRadius: '6px',
                              '&>span>svg': { fontSize: '1rem !important' },
                              '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                {
                                  transform: 'none',
                                  backgroundColor: '#293852',
                                  boxShadow: 'none',
                                },
                            }}
                            onClick={handleCallMeClose}
                          >
                            Call Me Now
                          </Button>
                          <Button
                            startIcon={<CalendarTodayIcon />}
                            size="large"
                            variant="contained"
                            rel="noopener noreferrer"
                            onClick={handleScheduleModalOpen}
                            sx={{
                              fontSize: '15px',
                              padding: '12px 24px',
                              backgroundColor: '#344767',
                              color: '#fff',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              textTransform: 'capitalize',
                              letterSpacing: 0.5,
                              borderRadius: '6px',
                              '&>span>svg': { fontSize: '1rem !important' },
                              '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                {
                                  transform: 'none',
                                  backgroundColor: '#293852',
                                  boxShadow: 'none',
                                },
                            }}
                          >
                            Schedule An Appointment
                          </Button>
                        </Box>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  {tableVilibility && (
                    <Card
                      sx={{
                        textAlign: 'left',
                        boxShadow: 0,
                        borderRadius: '0px 0px 8px 8px',
                        border: '1px solid #D2D6DA',
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        m={{ xs: 1, md: 2 }}
                        mb={{ xs: 1, md: 1 }}
                      >
                        <Typography
                          variant="h3"
                          fontWeight="medium"
                          fontSize={{ xs: '18px', md: '18px' }}
                          color="#75787B"
                        >
                          Retirement Bridge
                        </Typography>
                        <Box>
                          <ToggleButtonGroup
                            value={tableTimeHorizon}
                            exclusive
                            onChange={switchTimeHorizon}
                            aria-label="TimeHorizon"
                            sx={{
                              height: '36px',
                              alignSelf: 'center',
                              borderRadius: '36px',
                              background: '#A3A7AA',
                              border: '3px solid #A3A7AA',
                            }}
                          >
                            <ToggleButton
                              sx={{
                                borderRadius: '36px !important',
                                border: 'none',
                                color: '#fff',
                                textTransform: 'capitalize',
                                fontWeight: '500',
                                letterSpacing: '0.5px',
                                '&.Mui-selected': {
                                  backgroundColor: '#fff !important',
                                  color: '#75787B',
                                  fontWeight: '600',
                                },
                              }}
                              value="monthly"
                            >
                              Monthly
                            </ToggleButton>
                            <ToggleButton
                              sx={{
                                borderRadius: '36px !important',
                                border: 'none',
                                color: '#fff',
                                textTransform: 'capitalize',
                                fontWeight: '500',
                                letterSpacing: '0.5px',
                                '&.Mui-selected': {
                                  backgroundColor: '#fff !important',
                                  color: '#75787B',
                                  fontWeight: '600',
                                },
                              }}
                              value="yearly"
                            >
                              Yearly
                            </ToggleButton>
                          </ToggleButtonGroup>
                          <IconButton
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleTableMenuClick}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={tableMenuOpen}
                            onClose={handleTableMenuClose}
                            MenuListProps={{
                              'aria-labelledby': 'basic-button',
                            }}
                          >
                            <MenuItem onClick={openModalOnboarding}>
                              {/* <FormControlLabel
                              control={
                                <Switch
                                  onChange={handleTableStateChange}
                                  checked={tableStates.values}
                                  name="values"
                                />
                              }
                              label="Edit Values"
                              sx={{
                                margin: 0,
                                '>span:last-of-type': {
                                  fontWeight: 400,
                                  marginLeft: '10px',
                                },
                              }}
                            ></FormControlLabel> */}
                              <IconButton
                                sx={{
                                  padding: '1px 16px 2px 10px',
                                  color: '#344767',
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                              Edit Values
                            </MenuItem>
                            {/* <MenuItem>
                            <FormControlLabel
                              control={
                                <Switch
                                  onChange={handleTableStateChange}
                                  checked={tableStates.expand}
                                  name="expand"
                                />
                              }
                              label="Expand All"
                              sx={{
                                margin: 0,
                                '>span:last-of-type': {
                                  fontWeight: 400,
                                  marginLeft: '10px',
                                },
                              }}
                            ></FormControlLabel>
                          </MenuItem> */}
                            <MenuItem>
                              <FormControlLabel
                                control={
                                  <Switch
                                    onChange={handleTableStateChange}
                                    checked={tableStates.paycheck}
                                    name="paycheck"
                                  />
                                }
                                label="See Paycheck"
                                sx={{
                                  margin: 0,
                                  '>span:last-of-type': {
                                    fontWeight: 400,
                                    marginLeft: '10px',
                                  },
                                }}
                              ></FormControlLabel>
                            </MenuItem>
                            <MenuItem>
                              <FormControlLabel
                                control={
                                  <Switch
                                    onChange={handleTableStateChange}
                                    checked={tableStates.working}
                                    name="working"
                                  />
                                }
                                label="See Working"
                                sx={{
                                  margin: 0,
                                  '>span:last-of-type': {
                                    fontWeight: 400,
                                    marginLeft: '10px',
                                  },
                                }}
                              ></FormControlLabel>
                            </MenuItem>
                            <MenuItem>
                              <FormControlLabel
                                control={
                                  <Switch
                                    onChange={handleTableStateChange}
                                    checked={tableStates.difference}
                                    name="difference"
                                  />
                                }
                                label="See Difference"
                                sx={{
                                  margin: 0,
                                  '>span:last-of-type': {
                                    fontWeight: 400,
                                    marginLeft: '10px',
                                  },
                                }}
                              ></FormControlLabel>
                            </MenuItem>
                          </Menu>
                        </Box>
                      </Box>
                      <LeaveAndEarnings
                        deductions={deductions}
                        liabilities={liabilities}
                        readinessScoreAdjustedMax={readinessScoreAdjustedMax}
                        tableTimeHorizon={tableTimeHorizon}
                        tableStates={tableStates}
                      />
                    </Card>
                  )}
                </Grid>
              )}
              <ModalOnboarding
                open={showModalOnboarding}
                handleClose={closeModalOnboarding}
                modalHeader={'Update Your Income Statement'}
                steps={remainingOnboardingSteps.current}
              />
              <Grid item xs={12}>
                <Card
                  sx={{
                    textAlign: 'left',
                    boxShadow: 0,
                    borderRadius: 2,
                    border: '1px solid #D2D6DA',
                  }}
                >
                  <Box
                    px={{ xs: 2, md: 3 }}
                    py={2}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h3"
                        textTransform="capitalize"
                        color="#75787B"
                        fontSize="18px"
                      >
                        {daysTillRetirement > 0
                          ? 'Days Until Retirement'
                          : 'Days Since Retiring!'}
                      </Typography>
                    </Box>
                    <Box
                      textAlign="center"
                      onClick={handleRetirementFieldModalOpen}
                      sx={{
                        cursor: 'pointer',
                        width: { xs: '60%', sm: 'auto' },
                      }}
                    >
                      <Typography
                        variant="h3"
                        fontWeight="bold"
                        color="#262627"
                        fontSize={{ xs: '24px', md: '30px' }}
                      >
                        <BeachAccessIcon
                          sx={{ marginRight: '10px', marginBottom: '-3px' }}
                        />
                        <Box display={daysTillHolder === 0 ? 'none' : 'inline'}>
                          <Box display="inline-block" mx={0.5}>
                            <CountUp end={daysTillHolder} duration={1} />
                          </Box>
                          <Typography
                            component="span"
                            variant="h3"
                            color="#262627"
                            fontSize={{ xs: '24px', md: '30px' }}
                          >
                            Years,
                          </Typography>
                        </Box>
                        <Box display="inline-block" mx={0.5}>
                          <CountUp end={remainingDaysHolder} duration={1} />
                        </Box>
                        <Typography
                          component="span"
                          variant="h3"
                          color="#262627"
                          fontSize={{ xs: '24px', md: '30px' }}
                        >
                          Days
                        </Typography>

                        <Box>
                          <Typography
                            variant="h6"
                            textTransform="capitalize"
                            color="#262627"
                          >
                            {plannedRetirementMonth} {plannedRetirementDay},{' '}
                            {plannedRetirementYear}
                          </Typography>
                        </Box>
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
              {/* <ModalOnboarding
                open={showDeferredOnboarding}
                handleClose={closeDeferredModalOnboarding}
                modalHeader={'Deferred Resignation Explorer'}
                steps={remainingDeferredOnboardingSteps.current}
              />
              {!showDeferredResignation && (
                <Grid item xs={12}>
                  <Card
                    sx={{
                      textAlign: 'left',
                      boxShadow: 1,
                      borderRadius: 2,
                      backgroundColor: '#FFE9EC',
                      border: '4px solid #FD5C70',
                    }}
                  >
                    <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                      <Box display="flex">
                        <Box textAlign="left" width="100%">
                          <Box display="flex" alignItems="center">
                            <Box>
                              <Typography
                                variant="h3"
                                fontWeight="600"
                                mb={1}
                                fontSize="18px"
                                color="#262627"
                              >
                                🚨 See What A "Deferred Resignation" Would Look
                                Like For You
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <Typography
                              variant="body1"
                              sx={{ lineHeight: '1.2' }}
                              mb={2}
                              fontSize="14px"
                              color="#262627"
                            >
                              Answer a few questions to see the Pros and Cons of
                              accepting the Deferred Resignation offer. Make
                              sure you have all the info so you can make the
                              best decision.
                            </Typography>
                          </Box>
                          <Button
                            size="large"
                            fullWidth
                            variant="contained"
                            // href="https://www2.apptoto.com/b/team_parco"
                            // target="_blank"
                            // rel="noopener noreferrer"
                            onClick={openDeferredModalOnboarding}
                            rel="noreferrer"
                            sx={{
                              fontSize: '15px',
                              padding: '12px 24px',
                              backgroundColor: '#FD5C70',
                              color: '#fff',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              textTransform: 'capitalize',
                              letterSpacing: 0.5,
                              borderRadius: '6px',
                              '&>span>svg': { fontSize: '1rem !important' },
                              '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                {
                                  transform: 'none',
                                  backgroundColor: '#e35264',
                                  boxShadow: 'none',
                                },
                            }}
                          >
                            Explore My Options
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              )}
              {showDeferredResignation && (
                <Grid item xs={12}>
                  <Card
                    sx={{
                      textAlign: 'left',
                      boxShadow: 0,
                      borderRadius: 2,
                      border: '1px solid #D2D6DA',
                    }}
                  >
                    <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                      <Box display="flex">
                        <Box textAlign="left" width="100%">
                          <OnboardingInformation
                            header={`Evaluating the "Deferred Resignation"`}
                            subHeader={``}
                            styleAdjustments={{
                              textAlign: 'left',
                              '& h4': {
                                fontSize: '18px !important',
                                color: '#75787B',
                              },
                              '&>h4': {
                                fontSize: '16px !important',
                                fontWeight: '600',
                                color: 'rgba(0, 0, 0, 0.87)',
                              },
                            }}
                          ></OnboardingInformation>
                          <Button
                            startIcon={<CalendarTodayIcon />}
                            size="large"
                            fullWidth
                            variant="contained"
                            href="https://www2.apptoto.com/b/goparco_fork"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              fontSize: '15px',
                              padding: '12px 24px',
                              backgroundColor: '#344767',
                              color: '#fff',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              textTransform: 'capitalize',
                              letterSpacing: 0.5,
                              borderRadius: '6px',
                              '&>span>svg': { fontSize: '1rem !important' },
                              '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                {
                                  transform: 'none',
                                  backgroundColor: '#293852',
                                  boxShadow: 'none',
                                },
                            }}
                          >
                            Schedule An Appointment
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              )} */}
            </Grid>

            {searchParams.get('improveRetirementScore') ? (
              <Grid
                container
                spacing={3}
                data-testid="retirementScoreImprovement"
              >
                <Grid item xs={12}>
                  <SoftBox mt={3}>
                    <SoftTypography
                      textAlign="left"
                      variant="h3"
                      component="div"
                      color="dark"
                      mb={1}
                    >
                      Improve Your Retirement Score:
                    </SoftTypography>
                    <Grid container spacing={1}>
                      {/* <MissingOnboardingSteps />
                      <Recommendations
                        recommendations={intakeState.recommendations}
                      /> */}
                      <Grid item xs={12}>
                        <Card>
                          <SoftBox px={3} py={2}>
                            <SoftTypography
                              textAlign="left"
                              variant="h6"
                              component="div"
                              color="dark"
                              fontWeight="bold"
                            >
                              Optimize Your Retirement Plan
                            </SoftTypography>
                            <SoftTypography
                              textAlign="left"
                              color="inherit"
                              variant="body2"
                            >
                              Prioritize Your Long-Term Needs · Let PARCO Help
                              You Evaluate Your Retirement ·{' '}
                              <SoftButton
                                variant="text"
                                color="dark"
                                sx={{
                                  height: '100%',
                                  margin: 'auto',
                                  paddingTop: '5px',
                                  paddingLeft: '5px',
                                  fontSize: '15px',
                                }}
                                onClick={improveScoreHelp}
                              >
                                Talk to the team
                              </SoftButton>
                            </SoftTypography>
                          </SoftBox>
                        </Card>
                      </Grid>
                    </Grid>
                  </SoftBox>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
        {process.env.DEBUG && <CalculationDebug />}
      </Box>
      {/* <Footer /> */}
    </DashboardLayout>
  )
})

DashboardTwo.displayName = 'DashboardTwo'
